import { cn } from "@/lib/utils";
import formCheck from "../../assets/icons/form_progress_check.svg";

interface FormProgressProps {
  labels: string[];
  currentPage?: number;
}

export const FormProgress = ({ labels, currentPage = 1 }: FormProgressProps) => {
  return (
    <div className="al-bg-white al-rounded al-mb-8 al-grid al-grid-cols-[repeat(auto-fit,minmax(0,1fr))]">
      {labels.map((label, i) => {
        const isCurrentPage = i + 1 === currentPage;
        const isPageDone = i + 1 < currentPage;
        const formattedNumber = (i + 1 < 10 ? "0" : "") + (i + 1);

        return (
          <div
            key={i}
            className={cn(
              "al-py-3.5 al-px-6 al-items-center al-flex al-whitespace-nowrap al-border-r-2 al-border-black/10 last:al-border-r-0",
              isCurrentPage && "al-border-b-4 al-border-b-[#3f8cff]"
            )}
          >
            {isPageDone ? (
              <img src={formCheck} className="al-mr-2.5" alt="check" />
            ) : (
              <div
                className={cn(
                  "al-mr-2.5 al-flex al-justify-center al-items-center al-w-8 al-h-8 al-rounded-full al-border-2 al-font-medium al-text-xs al-leading-[18px]",
                  isCurrentPage
                    ? "al-border-[#247efe] al-bg-[#247efe] al-text-white"
                    : "al-border-[rgba(8,34,71,0.5)] al-text-[rgba(8,34,71,0.5)]"
                )}
              >
                {formattedNumber}
              </div>
            )}
            <div
              className={cn(
                "al-font-medium al-text-sm al-leading-[21px]",
                isCurrentPage || isPageDone
                  ? "al-text-[#247efe]"
                  : "al-text-[rgba(8,34,71,0.5)]"
              )}
            >
              {label}
            </div>
          </div>
        );
      })}
    </div>
  );
};
